var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.products.length)?_c('div',[_c('h4',{staticClass:"px-4 mb-6 md:mt-12 md:mb-9 text-1xl md:px-0"},[_vm._v("\n    Aanbevolen producten\n  ")]),_vm._v(" "),_c('RelatedProductCarousel',{attrs:{"products":_vm.products}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }